import { Pipe, PipeTransform } from '@angular/core';
import { ILanguageCodeValue, ILanguageText, TLocalizedString } from './localized.interface';
import { IWenji } from "libraries/interfaces/IWenji";
import { Yii } from "../../interfaces/Yii";

const DEFAULT_LANGUAGE: string = 'fr';

declare const wenji: IWenji;

@Pipe({ name: 'localized' })
export class LocalizedPipe implements PipeTransform {
    public transform(value: TLocalizedString): string {

        const YII_LANGUAGE: string = Yii && Yii.translate && Yii.translate.config ?
            Yii.translate.config.language:
            null;
        if(!value){
            return '';
        }
        if (typeof value === "string") {
            return value;
        }
        if (typeof value === "object" && !Array.isArray(value)) {
            return value[YII_LANGUAGE || wenji.ui.language]
                || value[DEFAULT_LANGUAGE]
                || Object.values(value).find(() => true);
        }

        if(Array.isArray(value) && (value as ILanguageCodeValue[]).length > 0 && (value as ILanguageCodeValue[])[0].languageCode) {
            return getLanguageCodevalue(value as string[] | ILanguageCodeValue[], YII_LANGUAGE);
        }

        if(Array.isArray(value) && (value as ILanguageText[]).length > 0 && (value as ILanguageText[])[0].language) {
            return getLanguageTextvalue(value as string[] | ILanguageText[], YII_LANGUAGE);
        }

        return "";
    }
}

function getLanguageCodevalue(value: string[] | ILanguageCodeValue[], YII_LANGUAGE: string): string{
    const languageCode: string = YII_LANGUAGE || wenji.ui.language || DEFAULT_LANGUAGE;
    const languageObject: ILanguageCodeValue = (value as ILanguageCodeValue[])
        .find((languageItem: ILanguageCodeValue): boolean => languageItem.languageCode.toLowerCase() === languageCode.toLowerCase());
    return ((languageObject || value[0]) as ILanguageCodeValue).value;
}

function getLanguageTextvalue(value: string[] | ILanguageText[], YII_LANGUAGE: string): string{
    const languageCode: string = YII_LANGUAGE || wenji.ui.language || DEFAULT_LANGUAGE;
    const languageObject: ILanguageText = (value as ILanguageText[])
        .find((languageItem: ILanguageText): boolean => languageItem.language.toLowerCase() === languageCode.toLowerCase());
    return ((languageObject || value[0]) as ILanguageText).text;
}